import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import config from 'config'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from 'srcReact/components/common2/Spinner'
import { openInNewTab, popupWindow } from 'srcReact/helpers/utils'
import { commonActions } from 'srcReact/components'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'

export default function SelectCalendarModal({
  isMixrOrganizer,
  mixrRecurrenceRule,
  mixrId,
  recurrenceUpdate = 'unique',
  closeModal
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [requested, setRequested] = useState(false)
  const [calType, setCalType] = useState('')
  const [calendarButtonClicked, setCalendarButtonClicked] = useState(false)
  const [availableAPIs, setAvailableAPIs] = useState([])

  const {
    common: { isNative },
    integration: {
      thirdPartyconnection: { loading: connectionLoading, API_connection, login_url }
    },
    organization: { current_organization },
    integration: {
      refreshToken,
      loading,
      eventData,
      calendarUrl,
      calendarType,
      calendarICSData,
      error,
      availableIntegrations
    }
  } = useSelector((state) => state)

  // const closeUserPermissionModal = () => {
  //   setShowUserPermissionModal(false)
  // }

  useEffect(() => {
    if (availableIntegrations?.list?.length === 0) {
      const organizationId = getCurrentOrgId()
      dispatch(integrationActions.getAvailableOrgConnections(organizationId))
    }
    //clean reducer state on unmount
    return () => {
      dispatch(integrationActions.clearData())
    }
  }, [])

  useEffect(() => {
    if (availableIntegrations?.list?.length > 0) {
      const activeAPIS = availableIntegrations.list.filter(
        (api) => api.usage === 'add_to_calendar' && api.is_active === 1
      )
      setAvailableAPIs(activeAPIS)
    }
  }, [availableIntegrations])

  useEffect(() => {
    if (!connectionLoading && calendarButtonClicked && calType !== 'ios') {
      setCalendarButtonClicked(false)
      //NA for ical for now
      //ask for user's permission if not already logged in with google or microsoft outlook, else add event to respective calendar automatically
      if (!API_connection && login_url) {
        allowConnection()
        // setShowUserPermissionModal(true)
      } else if (API_connection) {
        //need to check for native
        // if (isNative) {
        //   window.location =
        //     config.webUrl + `/ical/sync/${calType}/?mixr_id=${mixrId}&type=${calType}&refresh_token=${refreshToken}`
        //   return
        // }
        const organizationId = getCurrentOrgId()
        dispatch(integrationActions.setDefaultAddToCalendar(calType, organizationId))
        dispatch(integrationActions.postEventToCalendar(mixrId, calType))
        handleClose()
      }
    }
  }, [connectionLoading, API_connection, login_url, calendarButtonClicked])

  // useEffect(() => {
  //   //NA for ical for now.
  //   //after event is successfully added to calendar, redirected to html which came in response
  //   if (!loading && eventData) {
  //     if (calendarType === 'google') {
  //       openInNewTab(`${eventData.htmlLink}&authuser=${eventData.organizer?.email}`)
  //       handleClose()
  //     } else if (calendarType === 'microsoft') {
  //       openInNewTab(`${eventData.webLink}&authuser=${eventData.organizer?.emailAddress?.address}`)
  //       handleClose()
  //     }
  //   }
  // }, [eventData])

  const handleClose = (timout = 500) => {
    setTimeout(() => {
      if (closeModal) {
        closeModal()
      }
      dispatch(integrationActions.closeCalendarModal())
    }, timout)
  }

  const addToCalendar = (type) => {
    setCalType(type)
    setCalendarButtonClicked(true)
    // const currentOrgId = getNested(current_organization, 'info', 'id')
    if (
      //((config && config.env === 'prod' && currentOrgId && currentOrgId === 114) || config.env.startsWith('dev')) &&
      type === 'google' ||
      type === 'microsoft'
    ) {
      const organizationId = getCurrentOrgId()
      dispatch(integrationActions.getExternalAPIConnection(type, organizationId))
    } else {
      setRequested(true)
      // nativeapp
      if (mixrId && mixrId > 0) {
        if (isNative) {
          if (type === 'ics') {
            window.location =
              config.webUrl +
              `/ical/ios/?mixr_id=${mixrId}&type=ics&recurrence_rule=${isMixrOrganizer ? mixrRecurrenceRule : ''}`
          } else if (type === 'google') {
            window.location =
              config.webUrl +
              `/ical/google/?mixr_id=${mixrId}&type=google&recurrence_rule=${isMixrOrganizer ? mixrRecurrenceRule : ''}`
          }
          handleClose(0)
          return
        }
        dispatch(
          integrationActions.addToCalendarWithoutConnection(
            mixrId,
            type === 'microsoft' ? 'ics' : type,
            isMixrOrganizer ? mixrRecurrenceRule : ''
          )
        )
      }
    }
  }

  const allowConnection = () => {
    localStorage.setItem('addtocal', `${mixrId}|${calType}|${recurrenceUpdate}`)
    localStorage.setItem('integration_from', 'mixr_page')
    //  popupWindow(login_url, '', 600, 600)
    openInNewTab(login_url)
    // setShowUserPermissionModal(false)
    handleClose()
  }
  // const rejectConnection = () => {
  //   setShowUserPermissionModal(false)
  //   if (calType === 'google') {
  //     if (isNative) {
  //       window.location =
  //         config.webUrl +
  //         `/ical/google/?mixr_id=${mixrId}&type=google&recurrence_rule=${isMixrOrganizer ? mixrRecurrenceRule : ''}`
  //       handleClose(0)
  //       return
  //     }
  //     setRequested(true)
  //     dispatch(
  //       addToCalActions.addToCalendarWithoutConnection(mixrId, calType, isMixrOrganizer ? mixrRecurrenceRule : '')
  //     )
  //     handleClose()
  //   } else if (calType === 'microsoft') {
  //     if (isNative) {
  //       window.location =
  //         config.webUrl +
  //         `/ical/ios/?mixr_id=${mixrId}&type=ics&recurrence_rule=${isMixrOrganizer ? mixrRecurrenceRule : ''}`
  //       handleClose(0)
  //       return
  //     }
  //     dispatch(addToCalActions.addToCalendarWithoutConnection(mixrId, 'ics', isMixrOrganizer ? mixrRecurrenceRule : ''))
  //     setRequested(true)
  //   }
  // }

  const download = (filename, text) => {
    var element = document.createElement('a')
    element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  useEffect(() => {
    if (!loading && calendarType === 'google' && requested && calendarUrl.length > 0) {
      setRequested(false)
      setTimeout(() => {
        openInNewTab(calendarUrl)
        handleClose()
      })
    }
  }, [calendarUrl])

  useEffect(() => {
    if ((calendarType === 'ics' || calendarType === 'microsoft') && calendarICSData.length > 0 && requested) {
      setRequested(false)
      download('calendar.ics', calendarICSData)
      handleClose()
    }
  }, [calendarICSData])

  return (
    <React.Fragment>
      <div className={styles.container}>
        <h1 className={styles.title}>{t('mixrHome.moreOptions.addToCalendar')}</h1>
        <h2 className={styles.subTitle}>{t('mixrHome.moreOptions.selectCalendar')}</h2>
        <div className={styles.calendars}>
          <div className={styles.calendar}>
            <button className={styles.buttonContainer} onClick={() => addToCalendar('ics')}>
              <img alt={t('calendars.ical')} src={config.assetUrl + '/images/Apple_Calendar_Icon.png'} />
            </button>
            <span className={styles.calendarType}>{t('calendars.ical')}</span>
          </div>

          {availableAPIs?.length > 0 &&
            availableAPIs.map((api) => {
              if (api.external_api === 'google') {
                return (
                  <div className={styles.calendar}>
                    <button className={styles.buttonContainer} onClick={() => addToCalendar('google')}>
                      <img alt={t('calendars.google')} src={config.assetUrl + '/images/Google-calendarLogo.png'} />
                    </button>
                    <span className={styles.calendarType}>{t('calendars.google')}</span>
                  </div>
                )
              } else if (api.external_api === 'microsoft') {
                return (
                  <div className={styles.calendar}>
                    <button className={styles.buttonContainer} onClick={() => addToCalendar('microsoft')}>
                      <img alt={t('calendars.outlook')} src={config.assetUrl + '/images/Outlook-Logo.png'} />
                    </button>
                    <span className={styles.calendarType}>{t('calendars.outlook')}</span>
                  </div>
                )
              }
            })}
        </div>
        {error && <ErrorMessage text={error} center={true} className={styles.error} />}
        {loading && <Spinner />}
      </div>
      {/* {showUserPermissionModal && (
        <Modal isOpen={showUserPermissionModal} nested={true} handleClose={closeUserPermissionModal}>
          <UserPermissionModal
            calendarType={calType}
            allowConnection={allowConnection}
            rejectConnection={rejectConnection}
          />
        </Modal>
      )} */}
    </React.Fragment>
  )
}
